import {authService} from './auth.service';
import {isTenantForbiddenError} from '@utils/tenant';

let isRedirecting = false;

const forceAuthRedirect = reason => {
    if (isRedirecting || typeof window === 'undefined') {
        return;
    }

    isRedirecting = true;
    authService.logout();
    window.location.replace(`/login?reason=${reason}`);
};

export const attachSessionExpirationInterceptor = apiClient => {
    apiClient.interceptors.response.use(
        response => response,
        error => {
            const status = error?.response?.status;
            const hasAuthHeader = Boolean(error?.config?.headers?.Authorization || error?.config?.headers?.authorization);
            const hasToken = Boolean(authService.getToken());

            if (hasToken && hasAuthHeader && !isRedirecting) {
                if (isTenantForbiddenError(error)) {
                    forceAuthRedirect('tenant_mismatch');
                    return Promise.reject(error);
                }

                if (status === 401) {
                    forceAuthRedirect('token-expired');
                    return Promise.reject(error);
                }
            }

            return Promise.reject(error);
        }
    );
};
